import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecommendationsComponent } from './recommendations.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [
    RecommendationsComponent  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    RecommendationsComponent
  ]
})
export class RecommendationsModule { }